// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NKw3","footer":"styles_footer__1iQgY","passCodeTooltip":"styles_passCodeTooltip__2j3vi"};